module.exports = __webpack_public_path__ + "img/jt.0f0ce979.png";